import { useIsFetching, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getProducts } from "@/api";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

export function useProducts() {
  const isLoginFetching = useIsFetching({ queryKey: ["login"] });
  return useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const { response, data, error } = await getProducts();

      if (response.status === 403) {
        useSessionExpiredStore().setSessionExpired(true);
      }

      if (error) {
        throw error;
      }

      return data;
    },
    enabled: computed(() => isLoginFetching.value === 0),
  });
}
